import RoutingPaths from 'src/routing/RoutingConstants';
import { HeaderProps } from '../ds/Header';

const configuration: any = {
  logo: {
    image: '$(LOCAL_MEDIA_URL)/v1/eq-logo-full.svg',
    url: '/',
    external: true,
  },
  messages: {
    url: RoutingPaths.messages,
  },
  notifications: {
    url: RoutingPaths.alerts,
  },
  menuElements: [
    {
      label: 'Portfolio',
      url: RoutingPaths.portfolio,
    },
    {
      label: 'Dividends',
      url: RoutingPaths.dividends,
    },
    {
      label: 'Transactions',
      subLinks: [
        {
          label: 'Buy',
          url: `${RoutingPaths.buy}#InvestmentPlans`,
        },
        {
          label: 'Sell',
          url: RoutingPaths.sell,
          externalUrl: true,
        },
        {
          label: 'Stop Loss & Limit Orders ',
          url: RoutingPaths.stopLossAndLimitOrders,
        },
        {
          label: 'Replace Checks',
          url: RoutingPaths.checks,
          externalUrl: true,
        },
        {
          label: 'Report Lost Certificates',
          url: `${RoutingPaths.lostCertificates}#SelectCompanyAndAccount`,
          enableOnFeature: 'certificates',
          enableOnUserPreferences: 'allowLostCertificates',
        },
        {
          label: 'Broker Instructions',
          url: RoutingPaths.brokerInstructions,
          externalUrl: true,
        },
      ],
    },
    {
      label: 'Documents & Tax Forms',
      subLinks: [
        {
          label: 'Statements & Tax Forms',
          url: RoutingPaths.accountDocuments,
        },
        {
          label: 'Account Balance Reports',
          url: `${RoutingPaths.accountBalanceReports}`,
        },
        {
          label: 'Company Investment Plans',
          url: `/transactional/authenticated/newsol${RoutingPaths.registerDspp}`,
          externalUrl: true,
        },
      ],
    },
    {
      label: 'Employee Plan',
      url: RoutingPaths.espp,
      externalUrl: true,
    },
    {
      label: 'Contact Us',
      url: RoutingPaths.contactUs,
    },
  ],
  accountLinks: [
    {
      label: 'Account Management',
      url: RoutingPaths.accountManagement,
      iconUrl: '$(DESIGN_SYSTEM_MEDIA_URL)/v1/certificate-outline.svg',
    },
    {
      label: 'Profile Settings',
      url: '/umbraco/surface/ProfileSettingsSurface/Redirect',
      iconUrl: '$(DESIGN_SYSTEM_MEDIA_URL)/v1/icon-small-bounding-box.svg',
      externalUrl: true,
    },
    {
      label: 'Log Out',
      url: '/transactional/anonymous/signout',
      iconUrl: '$(DESIGN_SYSTEM_MEDIA_URL)/v1/icon-small-logout.svg',
      externalUrl: true,
    },
  ],
  mobileAccountLinks: [
    {
      label: 'Messages',
      url: RoutingPaths.messages,
      iconUrl: '$(DESIGN_SYSTEM_MEDIA_URL)/v1/icon-small-message.svg',
    },
    {
      label: 'Account Management',
      url: RoutingPaths.accountManagement,
      iconUrl: '$(DESIGN_SYSTEM_MEDIA_URL)/v1/certificate-outline.svg',
    },
    {
      label: 'Profile Settings',
      url: '/umbraco/surface/ProfileSettingsSurface/Redirect',
      iconUrl: '$(DESIGN_SYSTEM_MEDIA_URL)/v1/icon-small-bounding-box.svg',
      externalUrl: true,
    },
    {
      label: 'Log Out',
      url: '/transactional/anonymous/signout/',
      iconUrl: '$(DESIGN_SYSTEM_MEDIA_URL)/v1/icon-small-logout.svg',
      externalUrl: true,
    },
  ],
  buttonsSettings: {
    loginButtonName: 'Login',
    loginLink: '/transactional/authenticated/newsol/portfolio',
    loginExternal: true,
    registerButtonName: 'Register',
    registerLink: '/register',
    registerExternal: true,
  },
};

export default configuration as HeaderProps;
